import styled from 'styled-components';

const Background = styled.div({
  height: '100%',
  width: '100%',
  backgroundColor: '#04324F',
});

export { Background };
